export default "__VITE_ASSET__C3tLU6PT__"